import { serverAjaxPromise } from './request_helpers';
import { adjustFromSameNominalTimeForUser } from "@alltrails/shared/utils/timeHelpers";

export const updateTrack = (slug, trailId, { name, description, activity, date, rating, contentPrivacy }) => {
  const data = {
    rating,
    at_map: {
      name,
      description,
      activity: activity?.value || activity,
      // ISO format but using local time.
      created_at: adjustFromSameNominalTimeForUser(date).toISOString(),
      trail_id: trailId,
      contentPrivacy
    }
  };

  return serverAjaxPromise({
    method: 'PUT',
    url: `/explore/recording/${slug}`,
    data,
    dataType: 'json',
    resReducer: res => res.maps
  });
};

export const deleteTrack = mapId => {
  return serverAjaxPromise({
    method: 'DELETE',
    url: `/api/alltrails/maps/${mapId}`,
    resReducer: res => res
  });
};

export const getEditTrackParams = (url, intl) => {
  return serverAjaxPromise({
    method: 'GET',
    url,
    dataType: 'json',
    resReducer: res => {
      return {
        trackParams: {
          name: res.track.name,
          description: res.track.description,
          rating: res.track.rating,
          date: new Date(res.track.created_at),
          private: res.track.is_private,
          trailId: res.track.trail_id,
          contentPrivacy: res.track.content_privacy
        },
        initialMap: res.track,
        nearbyTrails: res.nearbyTrails.map(({ trail }) => ({ value: trail.trail_id, label: trail.name }))
      };
    }
  });
};
